import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="members"
export default class extends Controller {
  connect() {
  }

  clearTooltips() {
    $('[data-bs-toggle="tooltip"]').each(function(){
      $(this).tooltip('hide')
    })
  }

  searchUser(e) {
    e.preventDefault()
    var item = e.currentTarget
    var elem = item.closest('div')?.querySelector('input')

    if(elem.value.length > 0) {
      $.ajax({
        type: "GET",
        url: "/members/find_members",
        data: {
          name: elem.value
        },
        success: function(data) {
          if(data.status == 200){

            var option_list = ""
            const jsonArray = JSON.parse(data.users);
            if(jsonArray.length > 0) {

              // Accessing elements in the array
              $.each(jsonArray, function(index, object) {
                var name = object.last_name + ', ' + object.first_name + ' (' + object.company_name + ') -- ' + object.chapter_city + ', ' + object.chapter_state + ' | ' + object.chapter_nickname + ' - ' + object.chapter_meeting_day_time;
                option_list += '<option value="' + object.id + '">' + name + '</option>'
              });

              document.getElementById(item.dataset.field + "_other_users").innerHTML = option_list
            } else {
              alert("No users found")
              document.getElementById(item.dataset.field + "_other_users").innerHTML = ""
            }
          }
        }
      })
    }
  }


  toggleUsers(e){
    var item = e.currentTarget

    if(item.id == "giving_display_users") {
      if(document.getElementById('giving_myself_holder')) { document.getElementById('giving_myself_holder').classList.add('hidden') }
      if(document.getElementById('giving_my_users_holder')) { document.getElementById('giving_my_users_holder').classList.add('hidden') }
      if(document.getElementById('giving_other_users_holder')) { document.getElementById('giving_other_users_holder').classList.add('hidden') }
      if(document.getElementById('giving_new_user_holder')) { document.getElementById('giving_new_user_holder').classList.add('hidden') }
    }

    if(item.id == "receiving_display_users") {
      if(document.getElementById('receiving_myself_holder')) { document.getElementById('receiving_myself_holder').classList.add('hidden') }
      if(document.getElementById('receiving_my_users_holder')) { document.getElementById('receiving_my_users_holder').classList.add('hidden') }
      if(document.getElementById('receiving_other_users_holder')) { document.getElementById('receiving_other_users_holder').classList.add('hidden') }
      if(document.getElementById('receiving_new_user_holder')) { document.getElementById('receiving_new_user_holder').classList.add('hidden') }
    }

    document.getElementById(item.value + '_holder').classList.remove('hidden')
  }

}
